import React, { useEffect, useState } from "react";
import DownloadIcon from '@mui/icons-material/Download';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Text from "../../../../utils/Custom/text";
import { AddButton, CancelButton, SaveAndUpdate } from "../../../../utils/Custom/Button";
import { fetchQuery } from "../../../../utils/commonComponent/fetched";
import axiosWithToken from "../../../../utils/commonComponent/axiosTokenConfig";
import axios from "axios";
import { BASE_URL } from "../../../../global";
import { getPermissions } from "../../rbac/hasAccess";
import { validateRequiredFields } from "../../../../utils/commonComponent/errorAlert";
import { uploadJsonData, fetchJsonFromUrl } from "../../../../utils/commonComponent/handlejsonData";
import { generateTechnicalCompetencyPDF } from "./generateTechnicalCompetencyPDF";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import {
  Autocomplete,
  TextField,
  Paper,
} from "@mui/material";

// Complete dataset of IAF scopes and items from physical form
export const TECHNICAL_COMPETENCY_DATA = [
  {
    id: "iaf_17",
    iafScope: "17\nBasic Metals & Fabricated Metal Products",
    minEdu: "Diploma / BE Mechanical, Production, Industrial Engineering. OR Equivalent Diploma Degree*.",
    minReq: "BE Mech, Prod, Ind Eng. OR Equivalent.\n\n1 year / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "basic_metals",
        scope: "Basic Metals: Ferrous & Non-Ferrous Alloys & Non-metals",
        category: "Steels in the shape of Billets, Blooms, Slabs, Raw Material in the form of Plates, Sheets, Strips, Wires, Pipes, Tubes & Tubulars, Pipe & Tube fittings, Rolled section, Structural shapes, Forgings, Bars in different shapes, Flanges, Fasteners, Strainer plates, Metallic & Non-Metallic Gaskets, Castings, cast steel pipes, Line pipes, Foundation Bolts, Instrumentation fittings, Tools, Coated Steel Products, Raw material for Railways and other Scopes.",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "welding_consumables",
        scope: "Welding Consumables",
        category: "Electrodes, Bare filler wires",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "pressurized_vessels_1",
        scope: "Un-Pressurized Vessels / Items\nPressurized Vessels /Items",
        category: "Storage Tanks, Demister pads, Tower internals & Trays, Flare stacks, Chimneys, Steel pipes for sewage, Silos, Hoppers Strainers, Steam Traps, Expansion Bellows, Gas Cylinders, Heat Exchangers, Distillation columns with Internals, Reactors, Storage Tanks, Piping Fabrication, installation/testing onshore, offshore & projects, Steel pipe for water, Cylinders",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "pressurized_vessels_2",
        scope: "",
        category: "Multi-wall Pressure Vessels",
        defaultAuth: "C",
        defaultBasis: "I, II",
      },
      {
        key: "fabricated_structures",
        scope: "Fabricated Structures",
        category: "Welded Structures, Supports for Onshore and Offshore Purpose, Industrial Roofs, Platforms, Gratings,",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "precision_components",
        scope: "Precision components",
        category: "Precision Machined components, Bearings, Bushes, Assembly Components & Measurements by Precision Measuring instruments.",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
    ],
  },
  {
    id: "iaf_18",
    iafScope: "18\nMachinery & Equipment",
    minEdu: "Diploma / BE Mechanical, Production, Industrial Engineering. OR Equivalent Diploma Degree*.",
    minReq: "1 year / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "pumps",
        scope: "Pumps",
        category: "Centrifugal Pump, Reciprocating Pump, Positive Metering Pump",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "rotating_eq_1",
        scope: "Rotating equipment",
        category: "Compressors, Dryers, Axial & Centrifugal Fans, Blowers, cooling tower package",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "rotating_eq_2",
        scope: "",
        category: "Gear Box, Rotors",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "valves_equipment",
        scope: "Equipment",
        category: "All type of valves, Cascades, Petroleum Gas Dispensers",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "testing_equipment",
        scope: "Testing Equipment",
        category: "Calibration of UTM, Hardness testing Machine, Impact Testing Machine, & other testing Equipment.",
        defaultAuth: "C",
        defaultBasis: "I, II",
      },
      {
        key: "appliances",
        scope: "Appliances",
        category: "Domestic Appliances (Electrical & Non-Electrical), Diesel Generators, Industrial Mixers, Agitators, Heater",
        defaultAuth: "B",
        defaultBasis: "",
      },
      {
        key: "hvac",
        scope: "HVAC",
        category: "HVAC Systems,",
        defaultAuth: "C",
        defaultBasis: "",
      },
      {
        key: "lifting_equipment",
        scope: "Lifting Equipment",
        category: "All types of Cranes, Lifting Equipment & Accessories, Conveyor systems, Chains, Machine tools",
        defaultAuth: "C",
        defaultBasis: "",
      },
    ],
  },
  {
    id: "iaf_19",
    iafScope: "19\nElectrical Equipment",
    minEdu: "Diploma / BE Electricals, Electronics, Electronics and Tele OR Equivalent Diploma Degree*.",
    minReq: "1 year, / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "ht_lt_motors",
        scope: "HT & LT Motors",
        category: "Rotating Electrical Machines, Three Phase Induction motors,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "transformers",
        scope: "Transformers",
        category: "Power Transformers, Dry type power transformers, Voltage transformers, outdoor type three phase distribution transformers, Control Transformers for switchgear and control gear.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "cables_optical_fiber",
        scope: "Insulated Wires & cables / Cable trays Optical fiber cables",
        category: "Cross linked polyethylene insulated PVC sheathed cables, PVC Insulated light & heavy-duty electric cables, Aerial bunched Cables, Cable trays, Glands, Bus duct, Optical fiber cables",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "reactors",
        scope: "Reactors",
        category: "Shunt Reactors, Current limiting & neutral Earthing reactors, damping reactors, Tuning reactors, Earthing transformers arc suppression reactors, smoothing reactors,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "relays",
        scope: "Relays",
        category: "Electrical relays for power system protection and other systems.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "switch_gear",
        scope: "Switch Gear",
        category: "HV, MV, LV Switchgears & control gears/ Assemblies, Junction box,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "variable_freq_drives",
        scope: "Variable frequency drives",
        category: "Transformers & Inductors (Power, Audio, Pulse & switching) for electronic component, semi-conductor convertors,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "electrical_measuring_inst",
        scope: "Electrical Measuring instruments",
        category: "Direct acting indicating, analogue electrical measuring instruments, Testing equipment for AC/DC Electrical Energy meters,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "accumulators_batteries",
        scope: "Accumulators, Primary cells & batteries",
        category: "Lead acid batteries, Dry cell & batteries, Vented type nickel cadmium batteries, Lead acid batteries.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "battery_charger_invertors",
        scope: "Battery charger, invertors, Convertors",
        category: "Rectifiers & invertors, Uninterrupted power systems (UPS), Solid state invertors,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "flame_proof_enclosures",
        scope: "Flame proof Enclosures",
        category: "Flame proof equipment/device",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "transmitters",
        scope: "Transmitters",
        category: "Transmitters for use in process control systems,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "analyzers_measuring",
        scope: "Analyzers & Measuring Instruments",
        category: "Electrochemical Analyzers, RTD/Thermocouple, pressure Gauges, Level Gauges, and related Instruments.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "flow_meters",
        scope: "Flow meters",
        category: "Coriolis flow meters, Ultrasonic flow meters, Orifice plate flow meters, and other types of Meters.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "process_control_scada",
        scope: "Industrial process control equipment (PLC, DCS, SCADA, CCTV)",
        category: "Instrument system for process industry, Programmable controllers, Electrical surge protection, Instrumentation products, Industrial process control equipment, Fire & gas detection systems, EPBX Systems,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "gas_leak_detectors",
        scope: "Gas leak detectors",
        category: "Detectors used in low pressure liquefied petroleum gas burning appliances,",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "fire_detection_systems",
        scope: "Fire detection systems",
        category: "Fire detection & Alarming system",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "safety_devices_breaker",
        scope: "Safety related system/devices",
        category: "Vacuum circuit breaker, Isolator panel, APFC panels, Control Panels",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "electrical_safety_audit",
        scope: "Electrical Safety Audit",
        category: "In-Service - Periodical Inspections / Audits of Electrical Systems for Retail outlets/POL Depots/Terminals OISD 225:2010",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
  {
    id: "iaf_26",
    iafScope: "26\nGas supply",
    minEdu: "Diploma / BE Mech, Prod, Petrochemical Engg., Ind Engg. OR Equivalent Diploma Degree*",
    minReq: "1 Year/ Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "city_gas_distribution",
        scope: "City Gas Distribution Network,",
        category: "Gas Transmission & distribution piping systems, LPG, CNG pipelines, NG transmission pipelines, CGD Networks, Gas, Oil, Acid transportation lines or equivalent systems, Integrity Management System for Natural Gas Pipelines",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
  {
    id: "iaf_28",
    iafScope: "28\nFire and Safety Building Audits",
    minEdu: "Diploma / BE Electricals, Electronics, Electronics and Tele OR Equivalent Diploma Degree*.",
    minReq: "1 year, / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "building_audits",
        scope: "All types of Buildings",
        category: "In process Audits of Electrical and Fire Equipment's and instruments along with buildings\nInstallation & Maintenance check of fire hydrant, Hose Reels, Automatic fire detection & Alarm system, Electrical Wiring installation, commissioning checks",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
  {
    id: "iaf_31",
    iafScope: "31\nTransport, storage and communication",
    minEdu: "Diploma / BE Mech, Prod, Petrochemical Engg., Ind Engg. OR Equivalent Diploma Degree*",
    minReq: "1 year, / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "petroleum_pipeline_transport",
        scope: "Transportation of Petroleum & Petroleum Products by Pipeline",
        category: "Inspection of petroleum and petroleum product transportation systems including cross-country pipelines for oil, gas, and other liquids. Installation, commissioning, and in-service inspections of pipelines for petroleum products, natural gas, and other hazardous liquids",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "gas_supply_lpg",
        scope: "Gas Supply- LPG",
        category: "LPG distribution pipelines (urban, industrial, and residential), Storage tanks (bulk and cylinder systems), Valves, regulators, and pressure control devices Installation, commissioning, and in-service inspections for both new and existing LPG supply system",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "lpg_mounded_storage",
        scope: "LPG Over ground/ Mounded Storage and Bottling Facilities",
        category: "Inspection of LPG overground and mounded storage tanks, as well as bottling plant facilities, ensuring safe handling, storage, and bottling of LPG. Pre-installation, commissioning, and operational inspections of LPG storage and bottling systems.",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
  {
    id: "iaf_34",
    iafScope: "34\nEmergency Response & Disaster Management Plan",
    minEdu: "Diploma / BE Electricals, Electronics, Electronics and Tele OR Equivalent Diploma Degree*.",
    minReq: "1 year, / Training/ 1 to 3 Days Supervised working",
    rows: [
      {
        key: "emergency_erdmp",
        scope: "Emergency and Disaster Management for Oil and Gas Sector",
        category: "PNGRB's Codes of Practices for Emergency Response and Disaster Management Plan (ERDMP) Regulations -2010 Midstream and Downstream activities in Oil & Gas Sector, HIRA & Disaster Management",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
  {
    id: "iaf_general_qa_ndt",
    iafScope: "General / QA & NDT Scopes",
    minEdu: "Diploma / BE OR Equivalent Diploma / Degree* & Relevant Certification",
    minReq: "Supervised working",
    rows: [
      {
        key: "quality_assurance",
        scope: "Quality Assurance",
        category: "ITP, procedures for critical items, vendor evaluation of large organizations, Pre inspection meetings at large scale manufacturers, Kick off meetings with client, procedures Review/ Approval, furnace calibration.",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "laboratory_tests",
        scope: "Laboratory tests",
        category: "Check Testing at Lab of Material as per Codes & Standards.",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "welding_brazing",
        scope: "Welding & Brazing",
        category: "Qualification and Review of WPS/PQR/WPQ as per Codes & Standards.",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_rt",
        scope: "NDT-Mechanical",
        category: "RT",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_ut",
        scope: "",
        category: "UT",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_pt",
        scope: "",
        category: "PT",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_mt",
        scope: "",
        category: "MT",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_visual",
        scope: "",
        category: "Visual Examination",
        defaultAuth: "B",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_eddy_current",
        scope: "",
        category: "Eddy Current Testing",
        defaultAuth: "D",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_leak_testing",
        scope: "",
        category: "Leak Testing",
        defaultAuth: "D",
        defaultBasis: "I, II",
      },
      {
        key: "ndt_vacuum_box",
        scope: "",
        category: "Vacuum Box Testing",
        defaultAuth: "D",
        defaultBasis: "I, II",
      },
      {
        key: "elec_visual",
        scope: "Test on Electrical",
        category: "Visual Examination",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "elec_high_voltage",
        scope: "",
        category: "High Voltage Test",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "elec_induced_overvoltage",
        scope: "",
        category: "Induced Overvoltage Test",
        defaultAuth: "X",
        defaultBasis: "X",
      },
      {
        key: "elec_over_voltage",
        scope: "",
        category: "Over Voltage Test",
        defaultAuth: "X",
        defaultBasis: "X",
      },
    ],
  },
];

const TechnicalCompetencyRecord = ({ moduleId = 21 }) => {
  const params = useParams();
  const navigate = useNavigate();
  const permissions = getPermissions(moduleId);

  // Top header fields
  const [employeeId, setEmployeeId] = useState("");
  const [candidateName, setCandidateName] = useState("");
  const [officeLocation, setOfficeLocation] = useState("");

  // Signatures fields
  const [preparedById, setPreparedById] = useState("");
  const [preparedByName, setPreparedByName] = useState("");
  const [preparedByDate, setPreparedByDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [approvedById, setApprovedById] = useState("");
  const [approvedByName, setApprovedByName] = useState("");
  const [approvedByDate, setApprovedByDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  // Record values map: { [rowKey]: { authLevel: string, basis: string } }
  const [rowValues, setRowValues] = useState(() => {
    const initial = {};
    TECHNICAL_COMPETENCY_DATA.forEach((group) => {
      group.rows.forEach((r) => {
        initial[r.key] = {
          authLevel: "",
          basis: "",
        };
      });
    });
    return initial;
  });

  const [employees, setEmployees] = useState([]);
  const [existingRow, setExistingRow] = useState(null);

  // Fetch employees list
  const fetchEmployees = async () => {
    try {
      const empData = await fetchQuery(
        "SELECT e.id, e.name, e.employeesCode, e.location, eod.hrDesignation AS designation FROM employees e LEFT JOIN employeeOtherData eod ON eod.employeeId = e.id WHERE e.status != -1 ORDER BY e.name ASC"
      );
      setEmployees(empData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleEmployeeChange = (selectedEmp) => {
    if (selectedEmp) {
      setEmployeeId(selectedEmp.id);
      setCandidateName(selectedEmp.name || "");
      if (selectedEmp.location) {
        setOfficeLocation(selectedEmp.location);
      }
    } else {
      setEmployeeId("");
      setCandidateName("");
      setOfficeLocation("");
    }
  };

  const handleCellChange = (rowKey, field, value) => {
    setRowValues((prev) => ({
      ...prev,
      [rowKey]: {
        ...(prev[rowKey] || {}),
        [field]: value,
      },
    }));
  };

  // Check existing row in EmployeeForms table
  const checkExistingRow = async (empId) => {
    const targetId = empId || params?.id || employeeId;
    if (!targetId || targetId === "0") return;

    try {
      const checkQuery = {
        query: `SELECT id, competencyRecordUrl FROM EmployeeForms WHERE employeeID = '${targetId}' LIMIT 1`,
      };
      const checkResponse = await axiosWithToken.post(BASE_URL + "dynamic", checkQuery);
      const row = checkResponse?.data?.[0] || null;
      setExistingRow(row);
    } catch (error) {
      console.error("Failed to check existing row in EmployeeForms:", error?.response?.data || error.message);
      setExistingRow(null);
    }
  };

  const handleFetch = async () => {
    if (!existingRow?.competencyRecordUrl) return;
    try {
      const d = await fetchJsonFromUrl(existingRow.competencyRecordUrl);
      if (d) {
        if (d.candidateName) setCandidateName(d.candidateName);
        if (d.officeLocation) setOfficeLocation(d.officeLocation);
        if (d.rowValues) setRowValues(d.rowValues);
        if (d.preparedById) setPreparedById(d.preparedById);
        if (d.preparedByName) setPreparedByName(d.preparedByName);
        if (d.preparedByDate) setPreparedByDate(d.preparedByDate);
        if (d.approvedById) setApprovedById(d.approvedById);
        if (d.approvedByName) setApprovedByName(d.approvedByName);
        if (d.approvedByDate) setApprovedByDate(d.approvedByDate);
      }
    } catch (jsonErr) {
      console.error("Failed to load Technical Competency JSON file:", jsonErr);
    }
  };

  // Submit Handler
  const onSubmit = async () => {
    const targetEmpId = employeeId || params?.id;
    const fieldsToValidate = [
      { value: candidateName, label: "Name of Surveyor is required" },
      { value: officeLocation, label: "Office Location is required" },
    ];

    if (!validateRequiredFields(fieldsToValidate)) return;

    try {
      const payloadData = {
        employeeId: targetEmpId,
        candidateName,
        officeLocation,
        rowValues,
        preparedById,
        preparedByName,
        preparedByDate,
        approvedById,
        approvedByName,
        approvedByDate,
      };

      const uploadedUrl = await uploadJsonData(payloadData);

      if (!uploadedUrl) {
        console.error("Upload failed: no URL returned.");
        return;
      }

      // Save in EmployeeForms table
      const sqlQuery = existingRow
        ? {
            query: `UPDATE EmployeeForms SET competencyRecordUrl = '${uploadedUrl}' WHERE employeeID = '${targetEmpId}'`,
          }
        : {
            query: `INSERT INTO EmployeeForms (employeeID, competencyRecordUrl) VALUES ('${targetEmpId}', '${uploadedUrl}')`,
          };

      await axiosWithToken.post(BASE_URL + "dynamic", sqlQuery);

      setExistingRow((prev) => prev || { id: targetEmpId, competencyRecordUrl: uploadedUrl });
    } catch (error) {
      console.error("Submission failed:", error?.response?.data || error.message);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  useEffect(() => {
    if (params.id && params.id !== "0") {
      const foundEmp = employees.find((e) => String(e.id) === String(params.id));
      if (foundEmp) {
        handleEmployeeChange(foundEmp);
      }
      checkExistingRow(params.id);
    }
  }, [params?.id, employees]);

  useEffect(() => {
    if (existingRow?.competencyRecordUrl) handleFetch();
  }, [existingRow?.competencyRecordUrl]);

  const handleDownload = async () => {
    const payloadData = {
      employeeId: employeeId || params?.id,
      candidateName,
      officeLocation,
      rowValues,
      preparedById,
      preparedByName,
      preparedByDate,
      approvedById,
      approvedByName,
      approvedByDate,
    };
    const pdf = await generateTechnicalCompetencyPDF(payloadData);
    const safeName = (candidateName || "Surveyor").replace(/[^a-zA-Z0-9_-]/g, "_");
    pdf.save(`Technical-Competency-Record-${safeName}.pdf`);
  };

  return (
    <div>
      {(permissions.pdfDownload || permissions.allAccess) && (
        <div className="flex justify-end mb-4 gap-3">
          <AddButton
            id="btn-download-pdf"
            hoverTitle="Download PDF"
            icon={<DownloadIcon fontSize="small" />}
            onClick={() => handleDownload()}
          />
        </div>
      )}
      {/* Title */}
      <div className="flex justify-between items-center mb-4 border-b pb-2">
        <Text variant="h3" bold className="text-blue-600">
          Technical Competency Record
        </Text>
      </div>

      {/* Meta Bar: Name and Office Location */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 bg-gray-50 p-4 rounded-lg border border-gray-200">
        <div>
          <Autocomplete
            disabled={Boolean(params?.id && params.id !== "0")}
            options={employees}
            getOptionLabel={(option) => option.name || ""}
            value={employees.find((e) => String(e.id) === String(employeeId)) || null}
            onChange={(event, newValue) => handleEmployeeChange(newValue)}
            renderInput={(paramsInput) => (
              <TextField
                {...paramsInput}
                label="Name of Surveyor *"
                size="small"
                variant="outlined"
              />
            )}
          />
        </div>
        <div>
          <TextField
            label="Office Location *"
            size="small"
            fullWidth
            variant="outlined"
            disabled={Boolean(params?.id && params.id !== "0")}
            value={officeLocation}
            onChange={(e) => setOfficeLocation(e.target.value)}
          />
        </div>
      </div>

      {/* Table Container */}
      <Paper className="overflow-x-auto border border-gray-300 rounded-sm mb-6 shadow-sm">
        <table className="w-full border-collapse border border-gray-300 text-xs sm:text-sm">
          <thead>
            <tr className="bg-gray-100 text-gray-800 font-bold border-b border-gray-300">
              <th className="border border-gray-300 p-2 text-center w-[12%]">IAF Scope</th>
              <th className="border border-gray-300 p-2 text-left w-[18%]">Inspection Scope</th>
              <th className="border border-gray-300 p-2 text-left w-[32%]">Category / Range of Inspection</th>
              <th className="border border-gray-300 p-2 text-center w-[8%]">Authorization Level</th>
              <th className="border border-gray-300 p-2 text-left w-[14%]">Minimum Educational Qualification</th>
              <th className="border border-gray-300 p-2 text-left w-[10%]">Minimum Requirement for Level Grade B</th>
              <th className="border border-gray-300 p-2 text-center w-[6%]">Basis of Authorization</th>
            </tr>
          </thead>
          <tbody>
            {TECHNICAL_COMPETENCY_DATA.map((group) => {
              return group.rows.map((row, rIdx) => {
                const cellVal = rowValues[row.key] || { authLevel: "", basis: "" };
                return (
                  <tr key={row.key} className="hover:bg-blue-50/40 align-top border-b border-gray-200">
                    {/* IAF Scope Column (RowSpan) */}
                    {rIdx === 0 && (
                      <td
                        rowSpan={group.rows.length}
                        className="border border-gray-300 p-2 bg-gray-50 font-bold text-gray-800 text-center align-middle whitespace-pre-line"
                      >
                        {group.iafScope}
                      </td>
                    )}

                    {/* Inspection Scope */}
                    <td className="border border-gray-300 p-2 font-semibold text-gray-900 whitespace-pre-line">
                      {row.scope}
                    </td>

                    {/* Category / Range of Inspection */}
                    <td className="border border-gray-300 p-2 text-gray-800 whitespace-pre-line leading-relaxed">
                      {row.category}
                    </td>

                    {/* Authorization Level */}
                    <td className="border border-gray-300 p-1 text-center align-middle bg-white">
                      <input
                        type="text"
                        value={cellVal.authLevel || ""}
                        onChange={(e) => handleCellChange(row.key, "authLevel", e.target.value)}
                        placeholder=""
                        className="w-full text-center font-bold text-blue-900 border border-gray-300 rounded py-1 px-0.5 text-xs focus:ring-1 focus:ring-blue-500 focus:outline-none"
                      />
                    </td>

                    {/* Educational Qualification (RowSpan) */}
                    {rIdx === 0 && (
                      <td
                        rowSpan={group.rows.length}
                        className="border border-gray-300 p-2 text-gray-700 bg-gray-50/50 align-middle text-xs whitespace-pre-line leading-normal"
                      >
                        {group.minEdu}
                      </td>
                    )}

                    {/* Minimum Requirement (RowSpan) */}
                    {rIdx === 0 && (
                      <td
                        rowSpan={group.rows.length}
                        className="border border-gray-300 p-2 text-gray-700 bg-gray-50/50 align-middle text-xs whitespace-pre-line leading-normal"
                      >
                        {group.minReq}
                      </td>
                    )}

                    {/* Basis of Authorization */}
                    <td className="border border-gray-300 p-1 text-center align-middle bg-white">
                      <input
                        type="text"
                        value={cellVal.basis || ""}
                        onChange={(e) => handleCellChange(row.key, "basis", e.target.value)}
                        placeholder=""
                        className="w-full text-center font-bold text-gray-900 border border-gray-300 rounded py-1 px-0.5 text-xs focus:ring-1 focus:ring-blue-500 focus:outline-none"
                      />
                    </td>
                  </tr>
                );
              });
            })}
          </tbody>
        </table>
      </Paper>

      {/* Signatures Section: Prepared by & Approved by */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-6 p-4 border border-gray-300 rounded-lg bg-gray-50">
        {/* Prepared By */}
        <div className="space-y-3">
          <div>
            <Autocomplete
              options={employees.filter(
                (e) => String(e.id) !== String(params?.id || employeeId)
              )}
              getOptionLabel={(option) => option.name || ""}
              value={
                employees.find(
                  (e) =>
                    String(e.id) === String(preparedById) &&
                    String(e.id) !== String(params?.id || employeeId)
                ) || null
              }
              onChange={(e, val) => {
                if (val) {
                  setPreparedById(val.id);
                  setPreparedByName(val.name || "");
                } else {
                  setPreparedById("");
                  setPreparedByName("");
                }
              }}
              renderInput={(paramsInput) => (
                <TextField {...paramsInput} label="Prepared by" size="small" variant="outlined" fullWidth />
              )}
            />
          </div>
          <div>
            <TextField
              size="small"
              fullWidth
              type="date"
              label="Date"
              InputLabelProps={{ shrink: true }}
              value={preparedByDate}
              onChange={(e) => setPreparedByDate(e.target.value)}
            />
          </div>
        </div>

        {/* Approved By */}
        <div className="space-y-3">
          <div>
            <Autocomplete
              options={employees.filter(
                (e) => String(e.id) !== String(params?.id || employeeId)
              )}
              getOptionLabel={(option) => option.name || ""}
              value={
                employees.find(
                  (e) =>
                    String(e.id) === String(approvedById) &&
                    String(e.id) !== String(params?.id || employeeId)
                ) || null
              }
              onChange={(e, val) => {
                if (val) {
                  setApprovedById(val.id);
                  setApprovedByName(val.name || "");
                } else {
                  setApprovedById("");
                  setApprovedByName("");
                }
              }}
              renderInput={(paramsInput) => (
                <TextField {...paramsInput} label="Approved by" size="small" variant="outlined" fullWidth />
              )}
            />
          </div>
          <div>
            <TextField
              size="small"
              fullWidth
              type="date"
              label="Date"
              InputLabelProps={{ shrink: true }}
              value={approvedByDate}
              onChange={(e) => setApprovedByDate(e.target.value)}
            />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex gap-10 mt-5 justify-end">
        <CancelButton
          id="btn-cancel"
          label="Cancel"
          outline
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              navigate("/master/emptraining");
            }
          }}
        />
        {(permissions.save || permissions.allAccess) && (
          <SaveAndUpdate
            id="btn-save"
            label="Update"
            onClick={onSubmit}
          />
        )}
      </div>
    </div>
  );
};

export default TechnicalCompetencyRecord;
